import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

export function setupDayjs() {
  dayjs.extend(utc)
  dayjs.extend(timezone)
}
